import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import * as R from 'ramda';
import FlexCenter from 'App/components/styles/FlexCenter';
import { PdxPatientType } from './types/PatientType';

const PatientActionsCell = (findPatient, migratePatient) => {
    const Cell = ({ row }) => {
        const actualId = R.path(['original', 'ID'], row);
        const record = row.original;
        const isLinked = R.either(
            (r) => Boolean(R.prop('Linked', r)),
            (r) => R.has('Pdx', r)
        )(record || {});

        return isLinked ? (
            <FlexCenter>
                <Link to={`/editPatient/${actualId}`}>Edit</Link>
                <span style={{ margin: '2%' }}>|</span>
                <Link to={`/patient/${actualId}`}>Profile</Link>
            </FlexCenter>
        ) : (
            <FlexCenter>
                <Button variant="link" className="no-padding" onClick={() => findPatient(record?.ExternalId)}>
                    View
                </Button>
                <span style={{ margin: '2%' }}>|</span>
                <Button variant="link" className="no-padding" onClick={() => migratePatient(record?.ExternalId)}>
                    Migrate
                </Button>
            </FlexCenter>
        );
    };

    Cell.propTypes = {
        row: PropTypes.shape({
            original: PdxPatientType.isRequired,
        }).isRequired,
    };

    return Cell;
};

export default PatientActionsCell;
